import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSmartBanner } from '@kfc-global/react-shared/redux/Actions/SplashLoaderAction';
import { isMobileDevice, isEmptyObject } from 'common/utilities/utils';
import { ChannelManager } from 'common/manager';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const BannerData = props => {
  const { smartBannerData, showBanner } = useSelector(data => {
    return {
      smartBannerData: data?.contentReducer?.response?.smartBanner || null,
      showBanner: data?.splashLoaderReducer?.showSmartBanner || null,
    };
  });
  const { BannerCloseButton } = IMAGE_PATH;
  const { bannerImage = {} } = smartBannerData || {};
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const dispatch = useDispatch();

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const closeBannerButton = () => {
    dispatch(setSmartBanner(false));
  };

  const mobileBanner = () => {
    return (
      <>
        {showBanner && ChannelManager.isBrowser && isEmptyObject(bannerImage) && (
          <div id='kfc-banner-image' className='kfc-banner-image' data-testid='banner'>
            <img
              src={BannerCloseButton}
              alt='closeButton'
              className='close-button'
              onClick={closeBannerButton}
              data-testid='close-banner'
            />
            <img
              src={bannerImage?.fields?.file?.url}
              alt={bannerImage?.fields?.title}
              className='banner-image'
              useMap='#areaClickable'
            />
            <map name='areaClickable'>
              <area
                shape='rect'
                coords='302,0,395,63'
                href={smartBannerData?.url}
                data-testid='install-button'
                alt='Install Button'
              />
            </map>
          </div>
        )}
      </>
    );
  };
  return isMobile ? mobileBanner() : null;
};
export default BannerData;
